/* eslint-disable  @typescript-eslint/no-explicit-any */
/**
 * define interfaces for the layouts
 */

interface ILayoutStructure {
  name: string;
  components: any[];
}
interface IPageStructure {
  layout: any;
  placeholder?: any;
}
interface ILayoutComponent {
  id: string;
  config?: object;
  components?: ILayoutComponent[];
}

function pageIterator(
  pageData: IPageStructure,
  identifier: string,
  layout: string
) {
  const iterators = layout === "layout" ? pageData.layout : pageData.placeholder;
  if (layout === "layout") {
    return iterators.component[identifier];
  } else if (layout === "placeholder") {
    return iterators[identifier];
  }
}

/**
 * get layout data recursive way
 * @param layout 
 * @param pageData 
 */
function layoutIterator(layout: ILayoutComponent[], pageData: IPageStructure) {
  layout.forEach((item: ILayoutComponent) => {
    if (item.id) {
      if (String(item.id).indexOf("placeholder") > -1) {
        const identifier = String(item.id).substring(
          String(item.id).indexOf("?id=") + 4
        );
        const placeholderChildren = pageIterator(
          pageData,
          identifier,
          "placeholder"
        );
        if (placeholderChildren) {
          item.components = placeholderChildren;
        }
      } else {
        const identifier = item.id;
        const componentConfig = pageIterator(pageData, identifier, "layout");
        item = Object.assign(item, componentConfig);
      }
      if (item.components) {
        layoutIterator(item.components, pageData);
      }
    }
    return item;
  });
  return layout;
}

/**
 * get the layout JSON
 */
export function JSONConversion(
  layoutData: ILayoutStructure,
  pageData: IPageStructure
) {
  const layout = JSON.parse(JSON.stringify(layoutData));
  layoutData.components = layoutIterator(layout.components, pageData);
  return layoutData;
}
